/* eslint-disable arrow-body-style */
import convertToURLSearchParams from '@/helpers/urlParams';
import kyInstance from '@/services/Ky';

/**
 * Retrieves areas based on the provided query.
 * @param {Object} query - The query parameters for filtering areas.
 * @returns {Promise<Object[]>} - A promise that resolves to an array of areas.
 */
const getAreas = async (query) => {
  let searchParams;
  if (query) {
    searchParams = convertToURLSearchParams(query);
  }

  return kyInstance.get('areas', {
    searchParams,
  }).json();
};

/**
 * Retrieves a specific area by its ID.
 * @param {string} id - The ID of the area to retrieve.
 * @param {Object} query - The query parameters for the area retrieval.
 * @returns {Promise<Object>} - A promise that resolves to the retrieved area object.
 */
const getArea = async (id, query) => {
  let searchParams;
  if (query) {
    searchParams = convertToURLSearchParams(query);
  }

  return kyInstance.get(`areas/${id}`, { searchParams }).json();
};

/**
 * Creates a new area.
 * @param {Object} body - The request body containing the area data.
 * @returns {Promise<void>} - A promise that resolves when the area is created successfully.
 */
const createArea = async (body) => {
  return kyInstance.post('areas', { json: body });
};

/**
 * Edits an existing area.
 * @param {string} id - The ID of the area to be edited.
 * @param {Object} body - The request body containing the updated area data.
 * @returns {Promise<void>} - A promise that resolves when the area is edited successfully.
 */
const editArea = async (id, body) => {
  return kyInstance.patch(`areas/${id}`, { json: body });
};

/**
 * Deletes an area.
 * @param {string} id - The ID of the area to be deleted.
 * @returns {Promise<void>} - A promise that resolves when the area is deleted successfully.
 */
const deleteArea = async (id) => {
  return kyInstance.delete(`areas/${id}`);
};

export {
  getAreas,
  getArea,
  createArea,
  editArea,
  deleteArea,
};
